import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:list-box',
      order: 1,
      title: '订单管理',
      keepAlive: true,
    },
    name: 'OrderManagementBase',
    path: '/order-management',
    redirect: '/order-management/auth-order',
    children: [
      {
        component: () => import('#/views/workspace/authorized-order/index.vue'),
        meta: {
          icon: 'mdi:invoice-text-arrow-left',
          order: 1,
          title: '授权订单',
          keepAlive: true,
        },
        name: 'AuthorizedOrder',
        path: 'auth-order',
      },
      {
        component: () => import('#/views/market/tiktokAftersales/index.vue'),
        meta: {
          icon: 'mdi:clipboard-text-clock-outline',
          order: 2,
          title: '售后管理',
          keepAlive: true,
        },
        name: 'TiktokAftersales',
        path: 'aftersales',
      },
      {
        meta: {
          hideInMenu: true,
          title: '预上网管理',
        },
        name: 'OrderManagementPreOnlineLegacy',
        path: 'pre-online',
        redirect: '/pre-online/index',
      },
    ],
  },
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:clipboard-check-outline',
      order: 3,
      title: '预上网管理',
      keepAlive: true,
    },
    name: 'PreOnlineManagementBase',
    path: '/pre-online',
    redirect: '/pre-online/index',
    children: [
      {
        component: () => import('#/views/workspace/pre-online/index.vue'),
        meta: {
          icon: 'mdi:clipboard-check-outline',
          order: 2,
          title: '预上网管理',
          keepAlive: true,
        },
        name: 'PreOnlineOrder',
        path: 'index',
      },
    ],
  },
  {
    meta: {
      hideInMenu: true,
      title: '预上网管理',
    },
    path: '/workspace/pre-online',
    redirect: '/pre-online/index',
  },
];

export default routes;
